import React from "react";

// Slow editorial ribbon with outline (stroke) text.
export const Marquee = ({ items = [], dark = false }) => {
  const content = [...items, ...items];
  return (
    <div
      data-testid="marquee"
      className={`relative w-full overflow-hidden border-y py-6 md:py-8 ${
        dark ? "border-[#f2ece0]/15 bg-[#1a130b]" : "border-black/10 bg-[#f2ece0]"
      }`}
    >
      <div className="animate-marquee inline-flex items-center">
        {content.map((it, i) => (
          <span key={i} className="inline-flex items-center">
            <span
              className={`font-serif italic text-5xl md:text-7xl px-8 ${
                dark ? "text-stroke-light" : "text-stroke"
              }`}
            >
              {it}
            </span>
            <span className={`text-3xl ${dark ? "text-[#a65a34]" : "text-[#a65a34]"}`}>✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
